import { useEffect } from 'react';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const CALLBACK_URL = isLocalhost
  ? 'http://localhost:3000'
  : 'https://eventos-audiovisual.buenosaires.gob.ar';
const COGNITO_LOGIN_URL =
  `https://us-east-1gje4udc2u.auth.us-east-1.amazoncognito.com/login/continue?client_id=2rq374k38rqp0veo8r012v45c8&redirect_uri=${encodeURIComponent(CALLBACK_URL)}&response_type=code&scope=email+openid+phone&prompt=login`;

const Login = ({ onLogin }) => {
  useEffect(() => {
    // Limpiar cualquier token residual al cargar el login
    console.log('🔍 Verificando tokens residuales en Login...');
    
    // Prevenir navegación hacia atrás en página de login
    const handlePopState = (event) => {
      event.preventDefault();
      window.history.pushState(null, '', window.location.href);
    };

    // Agregar estado inicial
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    // Verificar si hay tokens válidos
    const token = sessionStorage.getItem('cognitoToken');
    const accessToken = sessionStorage.getItem('accessToken');
    const refreshToken = sessionStorage.getItem('refreshToken');
    
    // Si hay tokens, verificar si son válidos
    if (token && accessToken && refreshToken) {
      console.log('✅ Tokens encontrados, verificando validez...');
      onLogin && onLogin(token);
      // Limpiar el parámetro code de la URL si existe
      const url = new URL(window.location.href);
      if (url.searchParams.has('code')) {
        url.searchParams.delete('code');
        window.history.replaceState({}, document.title, url.pathname);
      }
      return;
    } else {
      // Si no hay tokens completos, limpiar todo
      console.log('🧹 No hay tokens válidos, limpiando datos residuales...');
      sessionStorage.clear();
      localStorage.clear();
    }

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      // Evitar doble uso del code
      if (sessionStorage.getItem(`cognito_code_used_${code}`)) {
        // Ya se usó este code, limpiar la URL y no hacer nada
        const url = new URL(window.location.href);
        url.searchParams.delete('code');
        window.history.replaceState({}, document.title, url.pathname);
        return;
      }
      // Marcar el code como usado
      sessionStorage.setItem(`cognito_code_used_${code}`, '1');
      // Intercambiar el code por tokens llamando al backend
      fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/auth/callback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code, redirectUri: CALLBACK_URL }),
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            // Guarda los tokens y marca como autenticado
            sessionStorage.setItem('cognitoToken', data.tokens.idToken);
            sessionStorage.setItem('accessToken', data.tokens.accessToken);
            sessionStorage.setItem('refreshToken', data.tokens.refreshToken);
            sessionStorage.setItem('userEmail', data.user.email || '');
            // Limpiar el parámetro code de la URL
            const url = new URL(window.location.href);
            url.searchParams.delete('code');
            window.history.replaceState({}, document.title, url.pathname);
            onLogin && onLogin(data.tokens.idToken);
          } else {
            // Si ya hay token válido, no mostrar alerta
            const token = sessionStorage.getItem('cognitoToken');
            if (!token) {
              alert(data.message || 'No se pudo completar el inicio de sesión. Por favor, vuelve a intentarlo. Si el problema persiste, contacta al administrador.');
            }
          }
        })
        .catch((e) => {
          // Si ya hay token válido, no mostrar alerta
          const token = sessionStorage.getItem('cognitoToken');
          if (!token) {
            alert('No se pudo completar el inicio de sesión. Por favor, vuelve a intentarlo. Si el problema persiste, contacta al administrador.');
          }
        });
    } else {
      // Si no hay code, limpiar todo y redirigir automáticamente al Hosted UI
      console.log('🔄 No hay código de autorización, limpiando sesión y redirigiendo a Cognito...');
      
      // Limpiar completamente sessionStorage y localStorage
      sessionStorage.clear();
      localStorage.clear();
      
      // Limpiar cookies también
      document.cookie.split(";").forEach(function(c) { 
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
      });
      
      // Pequeña pausa para asegurar que la limpieza se complete
      setTimeout(() => {
        console.log('🚀 Redirigiendo a Cognito con prompt=login...');
        window.location.href = COGNITO_LOGIN_URL;
      }, 100);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [onLogin]);

  return null; // No muestra nada, redirige automáticamente o procesa el callback
};

export default Login; 